// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__YBY7T","footer":"ModalFilter_footer__1rV3N"};